import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHANGE_SELECTED_PACKAGE_ID = 'PUBLISH_TERMS :: CHANGE_SELECTED_PACKAGE_ID';

export type TChangeSelectedPackageIdAction = IReduxAction<typeof CHANGE_SELECTED_PACKAGE_ID, string>;

export const changeSelectedPackageId = actionGenerator<typeof CHANGE_SELECTED_PACKAGE_ID, string>(
  CHANGE_SELECTED_PACKAGE_ID,
);
